import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const TrialBanner = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (!user?.isTrial || !user?.trialEndsAt) return null;

  const now = new Date();
  const end = new Date(user.trialEndsAt);
  const daysLeft = Math.max(0, Math.ceil((end - now) / (1000 * 60 * 60 * 24)));

  if (daysLeft <= 0) return null;

  return (
    <Box sx={{
      bgcolor: daysLeft <= 3 ? "#fef2f2" : "#fef9c3",
      borderBottom: `1px solid ${daysLeft <= 3 ? "#fecaca" : "#fde68a"}`,
      px: 2, py: 0.6, textAlign: "center",
      display: "flex", alignItems: "center", justifyContent: "center", gap: 1.5,
      flexWrap: "wrap",
    }}>
      <Typography sx={{
        fontSize: 13, fontWeight: 600,
        color: daysLeft <= 3 ? "#991b1b" : "#92400e",
      }}>
        {daysLeft === 1
          ? "Your free trial ends tomorrow!"
          : daysLeft <= 3
            ? `Your free trial ends in ${daysLeft} days`
            : `You're on a free trial — ${daysLeft} days remaining`}
      </Typography>
      <Button
        variant="contained"
        size="small"
        onClick={() => navigate("/app/plans")}
        sx={{
          textTransform: "none", fontWeight: 700, fontSize: 12, borderRadius: 1.5, px: 2, py: 0.3,
          bgcolor: daysLeft <= 3 ? "#dc2626" : "#f59e0b",
          "&:hover": {
            bgcolor: daysLeft <= 3 ? "#b91c1c" : "#d97706",
          },
          minHeight: 0,
        }}
      >
        Upgrade Now
      </Button>
    </Box>
  );
};

export default TrialBanner;
